import { useEffect, useRef } from "preact/hooks";
import { api } from "../api";
import { useOriginalAssets } from "../features";
import { useLive } from "../live";
import { refreshOpenCount } from "../openCount";

/** The open board supplies its own count; other routes refresh it on live changes. */
export function PeonWorkloadSync({ onOpenBoard }: { onOpenBoard: boolean }) {
  const original = useOriginalAssets();
  const generation = useRef(0);
  useEffect(() => {
    generation.current++;
    return () => { generation.current++; };
  }, [onOpenBoard, original]);
  useLive(async () => {
    if (onOpenBoard || !original) return;
    const current = ++generation.current;
    try {
      await refreshOpenCount(() => api.tasks.list("open"), () => generation.current === current);
    } catch { /* Retain the last known mood while offline. */ }
  }, [onOpenBoard, original]);
  return null;
}
